import React, { Component } from "react";

import styled from "styled-components";
import { Link } from "gatsby";
import Spinner from "react-spinkit";
import Helmet from "react-helmet";
import Markdown from "react-remarkable-with-plugins";
import CountUp from "react-countup";

import Label from "components/Elements/Label";
import SmallLabel from "components/Elements/SmallLabel";
import Button from "components/Elements/Button";

import {
  fetchUserData,
  checkUserPresence,
  retrievePostsUserWrote,
  retrievePostsUserCommented,
  retrievePostsUserUpvoted,
  getEnlights,
  getIBuiltThis
} from "api/db";
import { auth } from "api/firebase";

import { TwitterIcon, EmailIcon } from "react-share";
import { Row, Col } from "react-grid-system";
import _ from "lodash"; // exterminate this

const User = styled.div`
  margin: 0 auto;
  max-width: 70em;
  @media only screen and (max-width: 1024px) {
    padding: 2rem;
  }

`;

const SpinnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 300px;
`;

const Indicator = styled.div`
  height: 10px;
  width: 10px;
  border-radius: 50%;
  display: inline-block;
  background: ${props => props.c};
`;

const Image = styled.img`
  border-radius: 50%;
  height: 150px;
  max-width: 150px;
  margin-top: 30px;
  margin-bottom: 15px;

  -moz-box-shadow: 0 0 10px #e4e4e4;
  -webkit-box-shadow: 0 0 10px #e4e4e4;
  box-shadow: 0 0 10px #e4e4e4;
  transition: all 100ms ease;

  &:hover {
    -moz-box-shadow: 0 0 20px #438cee;
    -webkit-box-shadow: 0 0 20px #438cee;
    box-shadow: 0 0 20px #438cee;
    cursor: pointer;
  }
`;

const Points = styled.h3`
  margin: 5px 0px;
  background: #f4fbff;
  color: #2f80ed;
  display: inline-block;
  padding: 8px;
  border-radius: 8px;
`;

const Badge = styled.h4`
  background: #f4fbff;
  color: #2f80ed;
  display: inline-block;
  margin: 0;
  font-size: 15px;
  padding: 8px;
  border-radius: 8px;
`;

const Card = styled.div`
  max-height: 250px;
  border-radius: 4px;
  background: #fcfcfc;
  -moz-box-shadow: 0 0.2rem 3rem rgba(0, 0, 0, 0.08);
  -webkit-box-shadow: 0 0.2rem 1rem rgba(0, 0, 0, 0.08);
  box-shadow: 0 0.2rem 1rem rgba(0, 0, 0, 0.08);
  transition: all 200ms ease;
  margin-bottom: 24px;

  &:active,
  &:focus,
  &:hover {
    -moz-box-shadow: 0 0.2rem 3rem rgba(0, 0, 0, 0.2);
    -webkit-box-shadow: 0 0.2rem 1rem rgba(0, 0, 0, 0.2);
    box-shadow: 0 0.2rem 1rem rgba(0, 0, 0, 0.2);
  }

  h3 {
    text-align: center;
    padding: 16px;
    margin: 0;
    color: #333;
  }

  div {
    padding: 16px;
  }

  section {
    padding: 8px;
    text-align: center;

    h3 {
      color: #333;
      padding: 8px 0px;
    }
  }

  p {
    padding: 8px 0px;
  }

  .buttons {
    padding: 16px 0px;
    display: block;
  }
`;

const Img = styled.div`
  background-image: url(${props => props.src});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  height: 125px;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
`;

const IBuiltThisButton = styled.a`
  height: 100px;
  width: 50%;
  display: inline;
  padding: 8px;
  border: 2px solid ${props => props.bg};
  margin-right: 8px;
  color: #333;
  border-radius: 4px;
  transition: all 300ms ease;
  font-weight: bold;

  &:hover {
    color: #fff;
    background: ${props => props.bg};
  }

  @media only screen and (max-width: 1024px) {
    display: block;
    width: 90%;
    height: 48px;
    margin: 8px;
  }
`;

const Settings = styled.img`
  position: absolute;
  top: 12px;
  right: 20px;
  height: 28px;
  width: 28px;
`;

class ProfilePage extends Component {
  constructor(props) {
    super(props);
    this.getUpvoteActivity = this.getUpvoteActivity.bind(this);
    this.getCommentActivity = this.getCommentActivity.bind(this);
    this.getPostsUserWrote = this.getPostsUserWrote.bind(this);
    this.getEnlightCount = this.getEnlightCount.bind(this);

    this.state = {
      id: "",
      name: "",
      created_at: "",
      bio: "",
      loading: true,
      present: false,
      twitter: "",
      public_email: "",
      website: "",
      github: "",
      upvotes: [],
      photoURL: "",
      comments: [],
      posts: [],
      tags: [],
      enlights: 0,
      streak: 0,
      uid: "",
      ownPage: false,
      IBuiltThis: []
    };
  }

  componentDidMount() {
    let user = this.props.location.pathname.slice(6).toLowerCase();
    this.setState({ id: user });
    this.getUserData(user);
  }

  getUserData = user => {
    fetchUserData(user).on(
      "value",
      function(snapshot) {
        snapshot.forEach(childSnap => {
          let childData = childSnap.val();
          this.getUpvoteActivity(childSnap.key);
          this.getCommentActivity(childSnap.key);
          this.checkUserPresence(childSnap.key);
          this.getPostsUserWrote(childSnap.key);
          this.getEnlightCount(childSnap.key);
          this.getIBuiltThisSubmissions(childSnap.key);

          if (auth.currentUser) {
            if (childSnap.key == auth.currentUser.uid) {
              this.setState({
                ownPage: true
              });
            }
          }
          this.setState({
            uid: childSnap.key
          });
          let date = new Date(childData.created_at);
          var months = [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December"
          ];
          date = months[date.getMonth()] + " " + date.getFullYear();
          date = date.toString();
          this.setState({
            name: childData.username,
            created_at: date,
            bio: childData.bio,
            twitter: childData.twitter,
            public_email: childData.public_email,
            website: childData.website,
            github: childData.github,
            photoURL: childData.photoURL || "/img/avatar.png"
          });
          this.setState({
            tags: childData.tags
          });
          if (childData.streak) {
            this.setState({
              streak: childData.streak
            });
          }
        });
      }.bind(this)
    );
  };

  checkUserPresence = uid => {
    checkUserPresence(uid).once(
      "value",
      function(snapshot) {
        let exists = snapshot.val() !== null;
        if (exists) {
          this.setState({
            present: true
          });
        }
      }.bind(this)
    );
  };

  getPostsUserWrote = uid => {
    let views = 0;
    retrievePostsUserWrote(uid).then(snapshot => {
      snapshot.forEach(childSnap => {
        let childData = childSnap.val();
        if (childData.published) {
          this.setState(prevState => ({
            posts: [...prevState.posts, childData]
          }));
        }
        // fix to proper db query
        fetch(`https://enlight-9b523.firebaseio.com/views/views/${childData.id}.json`)
          .then(response => response.json())
          .then(data => {
            data = parseInt(data);
            if (data) {
              views += data;
            }
            this.setState({
              post_views: views
            });
          });
      });
      this.setState({ loading: false });
    });
  };

  getUpvoteActivity = uid => {
    retrievePostsUserUpvoted(uid).then(snapshot => {
      snapshot.forEach(childSnap => {
        let childData = childSnap.val();
        this.setState(prevState => ({
          upvotes: [...prevState.upvotes, childData]
        }));
      });
    });
  };

  getCommentActivity = uid => {
    var context = this;
    retrievePostsUserCommented().then(snapshot => {
      snapshot.forEach(function(snapshot1) {
        snapshot1.forEach(function(snapshot2) {
          if (snapshot2.val().uid === uid) {
            context.setState(prevState => ({
              comments: [...prevState.comments, snapshot2.val()]
            }));
          } else {
            return;
          }
        });
      });
    });
  };

  getEnlightCount(uid) {
    getEnlights(uid).then(snapshot => {
      let data = snapshot.val();
      if (data) {
        this.setState({ enlights: data.enlights });
      }
    });
  }

  getIBuiltThisSubmissions = uid => {
    getIBuiltThis(uid).once(
      "value",
      function(snapshot) {
        if (snapshot.val()) {
          this.setState({
            IBuiltThis: Object.values(snapshot.val())
          });
        }
      }.bind(this)
    );
  };

  render() {
    const {
      id,
      name,
      created_at,
      bio,
      loading,
      present,
      twitter,
      public_email,
      website,
      github
    } = this.state;

    var TwitterComponent;
    if (this.state.twitter) {
      TwitterComponent = (
        <div className="social-icon mr-2">
          <a href={`https://twitter.com/${twitter}`}>
            <TwitterIcon size={33} round />
          </a>
        </div>
      );
    } else {
      TwitterComponent = <span />;
    }

    var GithubComponent;
    if (this.state.github) {
      GithubComponent = (
        <div className="social-icon mr-2">
          <a
            className="near-black "
            href={`https://github.com/${github}`}
            title="GitHub"
          >
            <svg
              className="dib h2 w2"
              fill="currentColor"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 16 16"
              height="33"
              width="33"
            >
              <path d="M8 0C3.58 0 0 3.582 0 8c0 3.535 2.292 6.533 5.47 7.59.4.075.547-.172.547-.385 0-.19-.007-.693-.01-1.36-2.226.483-2.695-1.073-2.695-1.073-.364-.924-.89-1.17-.89-1.17-.725-.496.056-.486.056-.486.803.056 1.225.824 1.225.824.714 1.223 1.873.87 2.33.665.072-.517.278-.87.507-1.07-1.777-.2-3.644-.888-3.644-3.953 0-.873.31-1.587.823-2.147-.083-.202-.358-1.015.077-2.117 0 0 .672-.215 2.2.82.638-.178 1.323-.266 2.003-.27.68.004 1.364.092 2.003.27 1.527-1.035 2.198-.82 2.198-.82.437 1.102.163 1.915.08 2.117.513.56.823 1.274.823 2.147 0 3.073-1.87 3.75-3.653 3.947.287.246.543.735.543 1.48 0 1.07-.01 1.933-.01 2.195 0 .215.144.463.55.385C13.71 14.53 16 11.534 16 8c0-4.418-3.582-8-8-8" />
            </svg>
          </a>
        </div>
      );
    } else {
      GithubComponent = <span />;
    }

    var EmailComponent;
    if (this.state.public_email) {
      EmailComponent = (
        <div className="social-icon">
          <a href={`mailto:${public_email}`}>
            <EmailIcon size={33} round />
          </a>
        </div>
      );
    } else {
      EmailComponent = <span />;
    }

    var verified;
    if (this.state.posts[0]) {
      verified = <Badge> contributor </Badge>;
    } else {
      verified = <span />;
    }

    var streak;
    if (this.state.streak > 0) {
      streak = <Badge>🔥{this.state.streak}</Badge>;
    } else {
      streak = null;
    }

    var IBuiltThis;
    if (this.state.IBuiltThis[0]) {
      let data = this.state.IBuiltThis;
      IBuiltThis = (
        <div>
          <Label>Project Completions</Label>
          <br />
          {this.state.IBuiltThis.map((submission, i) => (
            <Card key={i}>
              <section>
                <Link to={`/projects/${submission.postId}`}>
                  <h3 className="text-2xl tracking-tight leading-snug font-bold text-gray-700">{submission.title} </h3>
                </Link>
                <span className="buttons">
                  {submission.github != "" ? (
                    <IBuiltThisButton
                      href={submission.github}
                      target="_blank"
                      bg="#f5af19"
                    >
                      {" "}
                      View Source Code{" "}
                    </IBuiltThisButton>
                  ) : null}

                  {submission.demo != "" ? (
                    <IBuiltThisButton
                      href={submission.demo}
                      target="_blank"
                      bg="#0394fc"
                    >
                      {" "}
                      View Project Live{" "}
                    </IBuiltThisButton>
                  ) : null}
                </span>
              </section>
            </Card>
          ))}
        </div>
      );
    } else {
      IBuiltThis = null;
    }

    var cohort;

    var contributorData;
    if (this.state.posts[0]) {
      contributorData = (
        <h4>
          <Badge>
            {" "}
            <CountUp end={this.state.posts.length} duration={2} />
          </Badge>
          &nbsp; posts // &nbsp;
          <Badge> {this.state.post_views} </Badge> views{" "}
        </h4>
      );
    } else {
      contributorData = null;
    }

    var posts;
    if (this.state.posts[0]) {
      let sortedPosts = _.sortBy(this.state.posts, function(obj) {
        return new Date(obj.date);
      });
      posts = (
        <Col lg={4} md={8} xs={12}>
          <br /> <br />
          <Label>Posts</Label>
          <br />
          {sortedPosts
            .map((data, i) => (
              <Link key={data.id} to={`/projects/${data.id}`}>
                <Card key={i}>
                  <Img src={data.img} />
                  <h3 className="text-2xl tracking-tight leading-snug font-bold text-gray-700">{data.title}</h3>
                </Card>
              </Link>
            ))
            .reverse()}
        </Col>
      );
    } else {
      posts = <div />;
    }

    var CommentsAndUpvotes;
    if (this.state.comments[0] || this.state.upvotes[0]) {
      let sortedComments = _.sortBy(this.state.comments, function(obj) {
        return new Date(obj.timestamp); // eventually remove loadash (soon!)
      });
      let sortedUpvotes = _.sortBy(this.state.upvotes, function(obj) {
        return new Date(obj.time);
      });
      CommentsAndUpvotes = (
        <div>
          {this.state.comments[0] ? (
            <div>
              <br /> <br />
              <Label>Comments</Label>
              <br />
              {sortedComments
                .map((data, i) => (
                  <Card key={i}>
                    <div>
                      <small>{new Date(data.timestamp).toLocaleString()}</small>
                      <br />@{id} commented on{" "}
                      <a href={`/projects/${data.post_id}#comments`}>
                        {data.post_title}
                      </a>
                      <p>{data.comment}</p>
                    </div>
                  </Card>
                ))
                .reverse()}
              <br />
            </div>
          ) : null}
          <Label>Upvotes</Label>
          <br />
          {sortedUpvotes
            .map((data, i) => (
              <Card key={i}>
                <div>
                  <small>{new Date(data.time).toLocaleString()}</small>
                  <br />@{id} upvoted{" "}
                  <a href={`/projects/${data.post_id}`}>{data.post_title}</a>
                </div>
              </Card>
            ))
            .reverse()}
        </div>
      );
    } else {
      CommentsAndUpvotes = <div />;
    }

    var WebsiteComponent;
    if (this.state.public_email) {
      WebsiteComponent = (
        <div className="social-icon mr-2">
          <a href={`${website}`}>
            <img
              className="h-8"
              alt="Website Icon"
              src="data:image/png;base64,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"
            />
          </a>
        </div>
      );
    } else {
      WebsiteComponent = <span />;
    }

    var IndicatorComponent;
    if (present) {
      IndicatorComponent = (
        <div>
          <Indicator c="#00cc00" /> <span>online</span>
        </div>
      );
    } else {
      IndicatorComponent = (
        <div>
          <Indicator c="#e4e4e4" /> <span>offline </span>
        </div>
      );
    }

    var points;
    if (this.state.enlights) {
      points = (
        <Points>
          <CountUp end={this.state.enlights} duration={2} /> enlights
        </Points>
      );
    } else {
      points = null;
    }

    // var settings;
    // if (this.state.ownPage) {
    //   settings = (
    //     <Link to="/account">
    //       <Settings src="/img/icons/settings-blue.png" />
    //     </Link>
    //   );
    // } else {
    //   settings = null;
    // }

    if (loading) {
      var data = (
        <SpinnerContainer>
          <Spinner name="ball-scale-multiple" color="#438cee" />
        </SpinnerContainer>
      );
    } else {
      data = (
        <div className="text-gray-800 max-w-screen-xl mx-auto">
          {/* {settings} */}

          <Row>
            <Col lg={4} md={4} xs={12}>
              <Image src={this.state.photoURL} />
              <h2 className="text-4xl tracking-tight leading-snug font-extrabold text-gray-700 mt-4">
                @<span className="gradient-text">{id}</span>{" "}
                {this.state.tags &&
                  this.state.tags.map(tag => {
                    return (
                      <Badge className="font-bold tracking-normal mr-2">
                        {tag}
                      </Badge>
                    );
                  })}
              </h2>
              <h2 className="text-3xl tracking-tight leading-snug font-bold text-gray-800 mt-2">
                {name}
              </h2>
              {points}
              {contributorData}
              <h2 className="text-xl font-bold text-gray-800 mt-4">
                <Markdown>{bio}</Markdown>
              </h2>
              <br />
              <div className="flex">
                {TwitterComponent}
                {GithubComponent}
                {WebsiteComponent}
                {EmailComponent}
              </div>
              <br /> <br />
              <SmallLabel>
                {" "}
                {IndicatorComponent}
                <br />
                Joined {created_at}
              </SmallLabel>
              <br />
              {/* <Label>Maker Log</Label>
              {makerLog} */}
              <br />
            </Col>
            {posts}
            <Col lg={4} md={4} xs={12}>
              <br />
              <br />
              {IBuiltThis ? IBuiltThis : null}
              {CommentsAndUpvotes}
            </Col>
          </Row>
        </div>
      );
    }

    return (
      <>
        <Helmet title={`@${id} | Enlight`} />
        <User>{data}</User>
      </>
    );
  }
}

export default ProfilePage;
